export const serverHostname = 'lumn-color-server.now.sh'
export const buildVersion = require('../../package.json').version
